const FALLBACK_PLANS = [
  {
    name: 'free',
    label: 'Free Plan',
    description: 'Get started with core analytics and compliance visibility.',
    dataRetentionDays: 31,
    minRefreshIntervalHours: 6,
    monthlyPrice: 0,
    yearlyPrice: 0,
    currency: 'usd',
    maxSites: 1,
    isDefault: true
  },
  {
    name: 'basic',
    label: 'Basic Plan',
    description: 'Faster refresh times, more site coverage, and priority ingestion.',
    dataRetentionDays: 90,
    minRefreshIntervalHours: 3,
    monthlyPrice: 49,
    yearlyPrice: 499,
    currency: 'usd',
    maxSites: 3
  },
  {
    name: 'pro',
    label: 'Pro Plan',
    description: 'Advanced reporting, deeper insights, and expanded retention windows.',
    dataRetentionDays: 180,
    minRefreshIntervalHours: 1,
    monthlyPrice: 99,
    yearlyPrice: 999,
    currency: 'usd',
    maxSites: 10
  },
  {
    name: 'ultimate',
    label: 'Ultimate Plan',
    description: 'Enterprise-grade refresh speeds, unlimited insights, and premium support.',
    dataRetentionDays: 365,
    minRefreshIntervalHours: 0,
    monthlyPrice: 199,
    yearlyPrice: 1999,
    currency: 'usd',
    maxSites: 999
  },
  {
    name: 'enterprise',
    label: 'Enterprise',
    description: 'Custom SLAs, dedicated onboarding, and white-glove support for scaled publishers.',
    dataRetentionDays: null,
    minRefreshIntervalHours: null,
    monthlyPrice: null,
    yearlyPrice: null,
    currency: 'usd',
    maxSites: null,
    isEnterprise: true
  }
];

const ENTERPRISE_PLAN = {
  name: 'enterprise',
  label: 'Enterprise',
  description: 'Custom SLAs, dedicated onboarding, and white-glove support for scaled publishers.',
  monthlyPrice: null,
  yearlyPrice: null,
  currency: 'usd',
  maxSites: null,
  dataRetentionDays: null,
  minRefreshIntervalHours: null,
  isEnterprise: true
};

const PLAN_ORDER = ['free', 'basic', 'pro', 'ultimate', 'enterprise'];

const normalizePlan = (plan = {}, fallback = {}) => {
  const merged = {
    ...fallback,
    ...plan
  };

  return {
    name: (merged.name || fallback.name || '').toLowerCase(),
    label: merged.label || fallback.label || 'Plan',
    description: merged.description || fallback.description || '',
    dataRetentionDays:
      typeof merged.dataRetentionDays === 'number'
        ? merged.dataRetentionDays
        : fallback.dataRetentionDays,
    minRefreshIntervalHours:
      typeof merged.minRefreshIntervalHours === 'number'
        ? merged.minRefreshIntervalHours
        : fallback.minRefreshIntervalHours,
    monthlyPrice:
      typeof merged.monthlyPrice === 'number' ? merged.monthlyPrice : fallback.monthlyPrice,
    yearlyPrice:
      typeof merged.yearlyPrice === 'number' ? merged.yearlyPrice : fallback.yearlyPrice,
    currency: (merged.currency || fallback.currency || 'usd').toLowerCase(),
    maxSites:
      typeof merged.maxSites === 'number' ? merged.maxSites : fallback.maxSites,
    isDefault: Boolean(merged.isDefault),
    isEnterprise: Boolean(merged.isEnterprise)
  };
};

const sortPlans = (plans = []) => {
  return [...plans].sort((a, b) => {
    const indexA = PLAN_ORDER.indexOf((a.name || '').toLowerCase());
    const indexB = PLAN_ORDER.indexOf((b.name || '').toLowerCase());
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });
};

export const buildPlanCatalog = (plans = []) => {
  const fallbackMap = FALLBACK_PLANS.reduce((acc, plan) => {
    acc[plan.name] = plan;
    return acc;
  }, {});

  const sourcePlans = Array.isArray(plans) && plans.length > 0 ? plans : FALLBACK_PLANS;

  const enriched = sourcePlans.map((plan) => {
    const planName = (plan?.name || '').toLowerCase();
    const fallback = fallbackMap[planName] || {};
    return normalizePlan(plan, fallback);
  });

  const hasEnterprise = enriched.some(
    (plan) => (plan.name || '').toLowerCase() === 'enterprise'
  );

  if (!hasEnterprise) {
    enriched.push({ ...ENTERPRISE_PLAN });
  }

  return sortPlans(enriched);
};

export { FALLBACK_PLANS, ENTERPRISE_PLAN };


